__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.7.1-766dd99-12585/_next/";